import React from 'react';
import 'pure-react-carousel/dist/react-carousel.es.css';
import "./carousel.css"
import QnectButton from "../../qnect-ui/qnect-button";

export const CarouselDot = (props) => {
    return (
        <div className="topDotContainer">
            {props.dotIcon}
            <span className="topControlsTitle">{props.dotTitle}</span>
        </div>
    )
};

function openInNewTab(url) {
    window.open(url, "_blank", "noreferrer");
}

export const CarouselContent = (props) => {
    return (
        <React.Fragment>
            <div className="sampleDetails">
                <div className="sampleDetailsTitle">
                    <h2>{props.carouselItemTitle}</h2>
                </div>
                <div className="sampleDetailsDescription">
                    <ul className="CarouselDetailsList">
                        <li>{props.carouselItemListItem1}</li>
                        {props.carouselItemListItem2 &&
                        <li>
                            <QnectButton field="seeMore" onClick={() => {openInNewTab(props.carouselItemListItem2)}}/>
                        </li>}
                    </ul>
                </div>
            </div>
        </React.Fragment>
    )
};

export default CarouselDot;
